import { Capacitor } from '@capacitor/core';

import { isCapacitorNative } from '@/core/utils/capacitor.utils';

/**
 * Instagram-style progressive blur along the top screen edge on iOS.
 * Content scrolling under the status bar softens upward; pointer-events none.
 * Mounted outside Ionic page transforms so `position: fixed` stays viewport-bound.
 */
export function NativeTopEdgeBlur() {
  if (!isCapacitorNative() || Capacitor.getPlatform() !== 'ios') {
    return null;
  }

  return (
    <div className="native-top-edge-blur" aria-hidden>
      <div className="native-top-edge-blur__layers">
        <div className="native-top-edge-blur__layer native-top-edge-blur__layer--1" />
        <div className="native-top-edge-blur__layer native-top-edge-blur__layer--2" />
        <div className="native-top-edge-blur__layer native-top-edge-blur__layer--3" />
        <div className="native-top-edge-blur__layer native-top-edge-blur__layer--4" />
        <div className="native-top-edge-blur__layer native-top-edge-blur__layer--5" />
      </div>
      <div className="native-top-edge-blur__tint" />
    </div>
  );
}
